// extracted by mini-css-extract-plugin
var _1 = "Layout-moduleLayout__MjtC4";
var _2 = "Layout-moduleheaderSearchOpen__h_44W";
var _3 = "Layout-modulemain__fxjFw Main-moduleMain__Z4xO0";
var _4 = "Layout-modulemenu__r3iCy Menu-moduleMenu__FuUyF";
export { _1 as "Layout", _2 as "headerSearchOpen", _3 as "main", _4 as "menu" }
